export const ONE_ROSTER_SPEC = 'OneRoster'
export const ONE_ROSTER_ROSTERING_SPEC = 'Rostering'
export const ONE_ROSTER_GRADEBOOK_SPEC = 'Gradebook'
export const ONE_ROSTER_GRADEBOOK_PUSH_SPEC = 'Gradebook Push'
export const ONE_ROSTER_GRADEBOOK_PULL_SPEC = 'Gradebook Pull'
export const ONE_ROSTER_RESOURCES_SPEC = 'Resources'
export const ONE_ROSTER_SPEC_V1P1 = '1p1'
export const ONE_ROSTER_SPEC_V1P2 = '1p2'
